export const reduxKey = '@@deviationSubmit';
export const actionKey = '@@deviationSubmit';

export enum SUBMIT_POPUP_ERROR_CODE {
  DEVIATION_INITIALIZATION_ERROR = 1,
  TIERS_INITIALIZATION_ERROR = 2,
  DEVIATION_SAVE_ERROR = 3,
  DEVIATION_PUBLISH_ERROR = 4,
  DEVIATION_DELETE_ERROR = 5,
  ITEM_COUNT_QUOTA_LIMIT_REACHED = 6,
}

export const SCHEDULE_ERROR_MAXED_OUT = 1;
export const SCHEDULE_ERROR_TIMESLOT_FULL = 2;
